import { ConfigInterface } from 'swr';
import { api, useApi, parseUrl } from '@gik/core/api';
import { ISupporter } from '@gik/core/models/gik/ISupporter';
import { downloadResponse } from '..';

export function getSupporters(inkindRouteId: string) {
  const finalUrl = parseUrl(`inkinds/${inkindRouteId}/supporters`);
  return api.get(finalUrl);
}

export function useSupporters(inkindRouteId: string, config?: ConfigInterface) {
  // important: the path must be null if there is no inkindRouteId yet, this is to prevent any loading from happening
  return useApi<ISupporter[]>(inkindRouteId ? `inkinds/${inkindRouteId}/supporters` : null, config);
}

export async function downloadSupporters(inkindRouteId: string, supporterEmails: string[]) {
  const finalUrl = parseUrl(`inkinds/${inkindRouteId}/supporters/export`);

  const response = await api.post(finalUrl, {
    headers: {
      Accept: 'application/octet-stream',
    },
    json: {
      supporterEmails,
    },
  });

  downloadResponse(response);
}
